import styled from "styled-components";

export const Card = styled.div`
  padding: 24px;
  border-radius: 12px;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.default[50]};
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
`;
